import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import SelectedModel from "components/Wizard/RightPanel/SelectedModel";

import * as runReducer from "containers/Run/reducer";
import * as wizardReducer from "containers/Wizard/reducer";
import * as setupReducer from "containers/Setup/reducer";

import { isEnabled } from "utils/featureFlags";

class SelectedModelContainer extends React.PureComponent {
  render() {
    return <SelectedModel {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    scrollToEnd: () => {
      dispatch(wizardReducer.scrollToEnd(0));
      return dispatch(runReducer.updateIsRightOpen(ownProps.id, ownProps.blueprintId, false));
    },

    continueWithModel: () => {
      dispatch(runReducer.updateIsNextStep(ownProps.id, true));
      dispatch(wizardReducer.scrollToEnd(0));
      return dispatch(runReducer.updateIsRightOpen(ownProps.id, ownProps.blueprintId, false));
    },

    updateChooseModel: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true)),
    updatePanelMode: (panelMode, id = ownProps.id) =>
      dispatch(runReducer.updatePanelMode(id, ownProps.blueprintId, panelMode))
  };
};

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = models && models.length > 0 ? models[0] : undefined;
  const selModel = runReducer.getSelModel(state, ownProps.id) ? runReducer.getSelModel(state, ownProps.id) : bestModel;

  return {
    model: selModel,
    models: models,
    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),
    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),

    trueAction: setupReducer.getTrueAction(state, ownProps.id, true),

    conversionGain: setupReducer.getConversionGain(state, ownProps.id),
    conversionCost: setupReducer.getConversionCost(state, ownProps.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SelectedModelContainer);
